import { Box, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';

export const PlatformFooter: React.FC = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-start',
        paddingBottom: 1,
        paddingLeft: 4,
      }}
    >
      <Typography
        sx={{
          color: 'text.secondary',
          fontSize: 14,
          marginRight: 1,
        }}
      >
        Revenue Platform Powered by
      </Typography>
      <VyIcon
        icon="LogoBlue"
        height={19}
        style={{
          width: '60px',
        }}
      />
    </Box>
  );
};
